import { useSuspenseQuery } from '@tanstack/react-query';
import api from '~/App/Role/api';

export const usePermissionQuery = () => {
  const { data } = useSuspenseQuery({
    queryKey: ['fetchPermissions'],
    queryFn: async () => {
      return api.fetchPermissions().then(({ permissions }) => permissions);
    },
  });

  return data;
};
